// 테스트 운영용 설정. 정식 서비스 전환 시 false로 변경하면 전체 기기를 표시한다.
export const HIDE_LONG_INACTIVE_DEVICES = true;
export const INACTIVE_HIDE_DAYS = 60;

// status_time은 현재 상태가 지속된 시간(시간 단위)이다.
export function filterVisibleDevices(
  devices,
  enabled = HIDE_LONG_INACTIVE_DEVICES
) {
  if (!enabled) return devices.slice();
  const threshold = INACTIVE_HIDE_DAYS * 24;
  return devices.filter((device) => {
    if (device?.status !== "DISABLE") return true;
    const value = device.status_time;
    if (typeof value !== "number" && typeof value !== "string") return true;
    if (typeof value === "string" && !value.trim()) return true;
    const hours = Number(value);
    return !Number.isFinite(hours) || hours < 0 || hours < threshold;
  });
}
